import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { ApiExportedFileConnectedDeviceModel, ApiExportedFilesConnectedDeviceModels, PrecizionRequest, StateExportConnectedRequest, ViewShapeConvertUnit } from '../_models/index';
import { environment } from '../../environments/environment';
import { catchError, filter, finalize, map, take } from 'rxjs/operators';
import { HandleService, HttpRequestService } from '../_services/index';
import { ApiExportGroupDevices, ApiExportGroupsDevices } from '../_models/precizion/ApiExportGroupsDevicesModel';
import { ComboGroupRecords, ComboRecord } from '../_models/front/combox/ComboRecord';
import { localStorageService } from './local-storage.service';

declare let doPostRequest: any;

//Sevice API Precizion.Exporter
@Injectable()
export class PrecizionServices {

    // #region config
    private baseUrl = environment.Precizion.url;

    //Indique qu'il est en cours de chargement via polling de statut début fin
    private _behaviorPollingProcessStatus = new BehaviorSubject<string>('');
    //Indique qu'il est en cours de chargement via polling des derniers status , terminé une fois que tous les statut sont terminés
    private _subjectPollingProcessStatus = new Subject<string>();

    /**dernier appel de polling des derniers status  */
    private _lastDatePolling: Date | null = null;

    //Indique si un process de maj de la liste des consoles perso est en cours
    private _isRefreshingDevices = new BehaviorSubject<string>("");

    //Indique si un process de récupératon initial de la liste des consoles est en cours
    private _isLoadingRefDevices = new BehaviorSubject<string>("");

    //indique si en mémoire dispose d'etat d'exports connectés
    private _includeConnectedStates: boolean | null = null;

    //indique si la popin des etat des console connectée est ouvert
    private _isPopinConnectedStatesOpen: boolean = false;

    /**Attribue si la popin des détail d export  conencté est ouverte ou non */
    public ChangePopinConnectedStatesOpen(_iIsPopinOpen: boolean) {
     
        this._isPopinConnectedStatesOpen = _iIsPopinOpen;
    }
    /**indique si la popin des détail d export  conencté est ouverte */
    public IsPopinConnectedStatesOpen(): boolean {
        return this._isPopinConnectedStatesOpen == true;
    }

    //indique si il comporte des statuts d'export connecté mis à jour
    private _includeDeviceChanges: boolean | null = null;

    //indique si il dispose de statut en cours de traitement en mémoire
    private _includeProcessStats: boolean | null = null;
    //le pooling de controle et maj des derniers statut se lance ttes les XX secondes
    //ne pas reduire pour avoir des conflits
    private _poolingStatusSeconds: number = 7;
    //durée max du pooling
    private _poolingDurationMaxMin: number = 5;
    //indique si un polling a deja été lancé
    private _poolingLaunched: boolean | null = null;

    private intervalPoolingCheckStates: number = 0;

    //indique si il comporte des statuts d'export connecté mis à jour
    public get IncludConnectedStateChanges(): boolean {
        return this._includeDeviceChanges !== null && this._includeConnectedStates == true;
    }

    //indique si il comporte des statuts d'export connecté mis à jour
    public get IsInLoadingConnectedStatus(): boolean {
        return this._poolingLaunched != null && this._poolingLaunched == true && this._includeProcessStats != null && this._includeProcessStats == true;
    }

    //supprime l'etat de modification détectées
    public RemoveConnectedStateChanges() {
        this._includeDeviceChanges = null;
    }
    //#endregion

    constructor(private httpRequestService: HttpRequestService) {

        this.ClearMemoryDevices();
        this._includeConnectedStates = null;
    }

    //#region Referential Devices

    /**
     * Indique si il est en cours de chargement du référentiel consoles
     * @returns 
     */
    public IsLoadingRefDevicesProcess() {
        return this?.IsLoadingRefDeviceInProcess() == true;
    }
    /**
     * Retourne les consoles utilisateur et le référentiel des modèles de console exportables selon groupement
     * complet
     * constitution et mise en mémoire
     * @returns 
     */
    public getExportableDevices(): Observable<ComboGroupRecords[]> {
        this.startDeviceLoading();
        const body = {};
        return this.httpRequestService.PostReqAsync<ApiExportGroupsDevices>(this.baseUrl + environment.Precizion.get_all_console, body, 'getExportableDevices')
            .pipe(
                map(
                  
                    (response) => {     
                        if (!response) {
                                this.stopDeviceLoading();
                                return [];
                        }
          
                        else {                  
                            let refDevices = ApiExportGroupsDevices.fromJson(response, true, false);
                            refDevices = this.TraceDevicesFailedGroupLoad(refDevices);
                            let refDatas = this.convertJsonDevicesToCombo(refDevices);
                            return refDatas;
                        }
                       
                    },
                ),
finalize(() => {
        this.stopDeviceLoading();
      })

            );
    }

    /**
* Retourne les consoles utilisateur exportable selon groupement
* ne recharge que les consoles utilisateurs pas le référentiel des modèles et pas de preselectionné (favoris)
* @returns 
*/
    private getExportableUserDevices(): Observable<ApiExportGroupsDevices | null> {
        this.startDeviceLoading();
        const body = {};
        return this.httpRequestService.PostReqAsync<ApiExportGroupsDevices>(this.baseUrl + environment.Precizion.get_user_devices, body, 'getPrecizions').pipe(map(
            (personalDevices) => {
                if (personalDevices?.length) {
                    //ne dispose que du référentiel du matériel perso
                    let refUserDevices = ApiExportGroupsDevices.fromJson(personalDevices, false, false);
                    refUserDevices = this.TraceDevicesFailedGroupLoad(refUserDevices);
                    this.stopDeviceLoading();
                    return refUserDevices;
                }
                this.stopDeviceLoading();
                return null;
            }));
    }

    /**
     * Si un groupement est en echec de chargement trace le log et nettoie l'objet
     * @param _oApiExportGroupsDevices groupements de devices à controler et nettoyer 
     * @returns 
     */
    private TraceDevicesFailedGroupLoad(_oApiExportGroupsDevices: ApiExportGroupsDevices): ApiExportGroupsDevices {
        if (_oApiExportGroupsDevices && (_oApiExportGroupsDevices.GetGroupRefModelFailed() !== undefined || _oApiExportGroupsDevices.GetGroupUserFailed() !== undefined)) {
            let groupModelFailed = _oApiExportGroupsDevices.GetGroupRefModelFailed();
            if (groupModelFailed) {
                //si on a géré back le mode pas d'exception sur erreur
                console.error('Echec de récupération du référentiel des modèles de console')
            }
            let groupUserFailed = _oApiExportGroupsDevices.GetGroupUserFailed();
            if (groupUserFailed) {
                //si on a géré back le mode pas d'exception sur erreur
                console.error('Echec de récupération de console personnelle', groupUserFailed.Description)
            }
            _oApiExportGroupsDevices.RemoveFailedGroups();
        }
        return _oApiExportGroupsDevices;
    }

    /**Changement du statut  vers "en cours de rechargement des consoles perso"*/
    private startDeviceRefresh(): void {
        this._isRefreshingDevices.next("PROCESS");
    }

    /**Changement du statut  vers "fin de rechargement des consoles perso"*/
    private stopDeviceRefresh(): void {
        this._isRefreshingDevices.next("END");
    }

    /**
     * Observable attend si il est  "en cours de rechargement des consoles perso" la fin de la maj
     * @returns 
     */
    public WaitEndRefreshUserDevicesInProgress(): Observable<boolean> {
        return this._isRefreshingDevices.asObservable().pipe(
            filter(value => value == "END"),
            take(1), map(() => true)
        );
    }

    /**
  * Indique si le statut est "en cours de rechargement des consoles perso"
  * @returns 
  */
    public IsRefreshInProcess() {
        return this._isRefreshingDevices.getValue() == "PROCESS";
    }

    /**Changement du statut  vers "chargement initial du référentiel"*/
    private startDeviceLoading(): void {
        this._isLoadingRefDevices.next("PROCESS");
    }

    /**Changement du statut  vers "fin de chargement initial du référentiel"*/
    private stopDeviceLoading(): void {
        this._isLoadingRefDevices.next("END");
    }

    /**
     * Observable attend si il est  "en fin de chargement initial du référentiel" la fin de la maj
     * @returns 
     */
    public WaitEndLoadingRefDevicesInProgress(): Observable<boolean> {
        return this._isLoadingRefDevices.asObservable().pipe(
            filter(value => value == "END"),
            take(1), map(() => true)
        );
    }
    /**
    * Indique si le statut est statut  vers "chargement initial du référentiel"
    * @returns 
    */
    public IsLoadingRefDeviceInProcess() {
        return this._isLoadingRefDevices.getValue() == "PROCESS";
    }



    /**
     * Après une modification des consoles utilisateur se charge de recharger QUE les consoles perso
     * (non les modèles standard)
     * il maj les données en mémoire une fois terminé
     */
    public refreshUserDevices() {
        this.startDeviceRefresh();
        let memComplet = this.GetMemoryRefApiDevices(true);
        if (memComplet != null && memComplet.length > 0) {
            //on ne garde que le référentiel des modèles les perso sont rechargés
            memComplet.PreserveOnlyReferentialModels();   
        }
        this.SetMemoryApiRefDevices(null);
        
        this.getExportableUserDevices().subscribe({
            next:(jsonPersonalDevices: ApiExportGroupsDevices | null) => {
                if (jsonPersonalDevices != null && jsonPersonalDevices?.length > 0) {
                    let refDevices = ApiExportGroupsDevices.fromJson(jsonPersonalDevices, false, true)
                    memComplet?.forEach((refPerso: ApiExportGroupDevices) => {
                        refDevices?.push(refPerso);
                    })
                    //conversion + save mémoire
                    this.convertJsonDevicesToCombo(refDevices);

                }
                else if (memComplet != null) {
                    //conversion + save mémoire il n a plus de console perso
                    this.convertJsonDevicesToCombo(memComplet);
                }

                this.stopDeviceRefresh();
            },
             error: (err) => {
                if(err && err.status && err.status == 401){
                    //authentication Smag failed 
                    
                    console.log('Erreur durant la récupération des consoles (auth)',err)
                }
                
                this.stopDeviceRefresh();
            }
        }
            
        )
    }
    

    /**
* Conversion de la liste des consoles utilisateurs et des models standard
* en enregistrement combo
* @param _iApiDevicesRef Api referentiel complet des consoles
* @param [_iUniqueUSbModels=true] true on filtre entre les models USB et perso USB que les perso
* @returns 
*/
    private convertJsonDevicesToCombo(_iApiDevicesRef: ApiExportGroupsDevices, _iUniqueUSbModels: boolean = true): ComboGroupRecords[] {
        let oComboGrpDevices = _iApiDevicesRef.MapToComboReferential(_iUniqueUSbModels);
        this.SetMemoryApiRefDevices(_iApiDevicesRef);
        this.SetMemoryGroupedComboDevices(oComboGrpDevices);
        return oComboGrpDevices;
    }

    /**Suppression de la mémoire des ApiRefDevices et GroupedComboDevices */
    private ClearMemoryDevices() {
        this.SetMemoryApiRefDevices(null);
        this.SetMemoryGroupedComboDevices(null);
    }

    /**
     * Modifie la liste referentiel combox des Devices
     * en affectant la preselection sur ce device
     * @param _iSelected device a indiqué preselectionné
     * @returns boolean 
     */
    public ChangeMemorySelectedDevice(_iSelected: ComboRecord): boolean {
        if (_iSelected?.Id) {
            let mem = this.GetMemoryGroupedComboDevices(true);
            let outFunction = false;
            if (mem && mem?.length > 0) {
                mem.forEach((f: ComboGroupRecords) => {
                    if (!outFunction) {
                        let slecte = f.GetPreSelected();
                        if (slecte && slecte.Id == _iSelected.Id) {
                            outFunction = true;
                        }
                        f.SetPreSelected(_iSelected.Id);
                    }
                })
            }
            if (!outFunction) {
                this.SetMemoryGroupedComboDevices(mem);
                return true;
            }
        }
        return false;
    }

    /**
     * 
     * @param _iInstanceObject true on instancie l'objet pour acceder à ses propres fonctions, sinon objet json retourné
     * @returns retourne la liste référentiel combo consitutée des devices en mémoire sinon null
     */
    public GetMemoryGroupedComboDevices(_iInstanceObject: boolean): ComboGroupRecords[] | null {
        let memDatas = this.GetMemoryReferential("groupedComboDevices");
        if (memDatas && memDatas?.length > 1) {
            if (_iInstanceObject == true) {
                return ComboGroupRecords.fromJson(JSON.parse(memDatas));
            } else {
                return JSON.parse(memDatas) as ComboGroupRecords[]
            }

        } else {
            return null;
        }
    }

    /**
   * @param _iInstanceObject true on instancie l'objet pour acceder à ses propres fonctions, sinon objet json retourné
   * @returns retourne la liste  référentiel Api des devices en mémoire sinon null
   */
    public GetMemoryRefApiDevices(_iInstanceObject: boolean): ApiExportGroupsDevices | null {
        let memDatas = this.GetMemoryReferential("referentialDevices");

        if (memDatas && memDatas?.length > 0) {
            if (_iInstanceObject == true) {
                return ApiExportGroupsDevices.fromJson(JSON.parse(memDatas), false, true);
            } else {
                return JSON.parse(memDatas) as ApiExportGroupsDevices;
            }

        } else {
            return null;
        }
    }

    /**
 * Enregistre en mémoire la liste référentiel combo consitutée des devices 
 * @param _iComboGrpDevices  liste référentiel combo consitutée
 */
    private SetMemoryGroupedComboDevices(_iComboGrpDevices: ComboGroupRecords[] | null) {
        if (!_iComboGrpDevices) {
           localStorageService.remove('groupedComboDevices');
        } else {
            localStorageService.set('groupedComboDevices', JSON.stringify(_iComboGrpDevices));
        }
    }

    /**
     * Enregistre en mémoire la liste référentiel Api des devices 
     * @param _iApiDevicesRef liste référentiel Api des devices 
     */
    private SetMemoryApiRefDevices(_iApiDevicesRef: ApiExportGroupsDevices | null) {
        if (!_iApiDevicesRef) {
           localStorageService.remove('referentialDevices');
        } else {
            localStorageService.set('referentialDevices', JSON.stringify(_iApiDevicesRef));
        }
    }

    //#endregion

    //#region user Export Connected file

    /**
     * Mise en mémoire du status d'un export connecté
     * @param _iExportInitialStateConnected 1 statut d export connecté
     */
    public AddMemoryNewExportConnectedState(_iExportInitialStateConnected: ApiExportedFileConnectedDeviceModel) {
        let states: ApiExportedFileConnectedDeviceModel[] = [];
        states.push(_iExportInitialStateConnected);
        this.AddMemoryExportsConnectedStates(states, true)
    }
    /**
     * Ajout /maj en mémoire de nouveaux ou maj d'exports de fichier connectés
     * maj du statut "_includeConnectedStates" selon
     * @param _iExportsStatesConnected liste status d exports connectés
     * @param _iIsNewExport true on est sur l export , false on est sur le resultat de controle d'état de transfert
     * @returns si les nouveaux statut ont été remis
     */
    private AddMemoryExportsConnectedStates(_iExportsStatesConnected: ApiExportedFileConnectedDeviceModel[], _iIsNewExport: boolean): boolean {
        let oCntNewStatus = 0;
        if (_iExportsStatesConnected && _iExportsStatesConnected.length) {
            let memoryStates = this.GetMemoryExportConnectedDevices(true);

            if (!memoryStates || memoryStates == undefined || memoryStates.Exists() == false) {
                let nws = new ApiExportedFilesConnectedDeviceModels();
                nws.AddRange(_iExportsStatesConnected);
                memoryStates = nws;
                oCntNewStatus++;
            } else {
                if (_iIsNewExport == true) {
                    //existe pas , pas de contrôle
                    memoryStates.AddRange(_iExportsStatesConnected);
                    oCntNewStatus++;
                } else {
                    //remplacer ceux qui existeraient
                    for (let ndxnwRow = 0; ndxnwRow < _iExportsStatesConnected.length; ndxnwRow++) {
                        const fState = _iExportsStatesConnected[ndxnwRow];
                        if (fState.Exists() && fState.GetExportRequestUid()) {
                            let updated = memoryStates.UpdateTransfertStatus(fState, false);
                            if (updated == true) {
                                oCntNewStatus++;
                            }
                        }
                    }
                }
            }
    
            this.SetMemoryExportConnectedDevices(memoryStates);
           
        }
        return oCntNewStatus > 0;
    }

    /**
     * Mise en mémoire d'exports de fichier connectés
     * @param _iApiExportConenctedStates liste d exports enregistrés en mémoire, ou null => efface en mémoire
     */
    private SetMemoryExportConnectedDevices(_iApiExportConenctedStates: ApiExportedFilesConnectedDeviceModels | null) {

        if (_iApiExportConenctedStates == null) {
            localStorageService.remove('ApiStateExportConnectedDevice');
            this._includeConnectedStates = false;
        } else {
            this._includeConnectedStates = true;
             
            localStorageService.set('ApiStateExportConnectedDevice', JSON.stringify(_iApiExportConenctedStates));
        }
    }


    /**
     * Indique si il existe en mémoire des states d export de fichier console connectées
     * @returns 
     */
    public ExistExportStateConnectedDevices(): boolean {
        if (this._includeConnectedStates == null) {
            let vls = this.GetMemoryExportConnectedDevices(false);
            this._includeConnectedStates = vls !== undefined && vls?.Exports?.length > 0;
        }
        return this._includeConnectedStates == true;
    }

    /**
     * Retourne la liste des états des exports connectés
     * @returns 
     */
    public GetMemoryStatesExportConnectedDevices(): ApiExportedFilesConnectedDeviceModels | undefined {
        return this.GetMemoryExportConnectedDevices(true);
    }

    /**
     * Retourne l'objet ApiExportedFilesConnectedDeviceModels de la mémoire
     * @param _iInstanceObject true instancie false juste mappé (si false ne pas utiliser les fonction de ApiExportedFilesConnectedDeviceModels : ts?.Exports.length oui)
     * @returns 
     */
    private GetMemoryExportConnectedDevices(_iInstanceObject: boolean): ApiExportedFilesConnectedDeviceModels | undefined {
        let memDatas = this.GetMemoryReferential("ApiStateExportConnectedDevice");

        if (memDatas && memDatas?.length > 0) {
            let oResults: ApiExportedFilesConnectedDeviceModels = new ApiExportedFilesConnectedDeviceModels();
            if (_iInstanceObject == true) {
                const rowJsonAll = JSON.parse(memDatas);
                oResults.bindByJson(rowJsonAll);
                for (let ndxA = 0; ndxA < rowJsonAll.length; ndxA++) {

                    const rowJson = rowJsonAll[ndxA];
                    if (rowJson && rowJson.FileExporting) {
                        oResults.Add(new ApiExportedFileConnectedDeviceModel(rowJson.FileExporting, true))
                    }
                }
                return oResults;
            } else {

                return JSON.parse(memDatas) as ApiExportedFilesConnectedDeviceModels;
            }

        } else {
            return undefined;
        }
    }

    //#endregion
    /**
     * Export les preconisations recupère l'url de telechargmeent
     * pour les connectés recupere le statut jusque l appel pour envoi sur le compte connecté 
     * @param param 
     * @returns 
     */
    public getConsoleDownload(param: PrecizionRequest): Observable<ApiExportedFileConnectedDeviceModel> {

        return this.httpRequestService.PostRequest(this.baseUrl + environment.Precizion.get_console_download, param, 'getConsoleDownload').pipe(
            map(
                (response) => {
                    if (response) {
                        let oExport = new ApiExportedFileConnectedDeviceModel(response, true);

                        if (param.IsConnectedDevice && oExport && oExport.IsConnectedExport()) {
                            //export connecté contrôlé avant le transfert vers le compte
                            this.AddMemoryNewExportConnectedState(oExport);
                        }
                        return oExport;
                    } else {
                        return new ApiExportedFileConnectedDeviceModel(null, false);;
                    }

                })
        );
    }

    /**
     * indique si il dispose de statut en cours
     * @returns 
     */
    public IncludeConnecteStatesInProgress(): boolean {

        let val = this.GetParamsRequestConnecteStatesInProgress(true);
        return val != undefined && val?.requestUids?.length > 0;
    }
    /**
     * Retourne sous forme de request les export state en cours
     * @param _iOnlyInProgress true seul ceux en cours, false : tous
     * @returns 
     */
    public GetParamsRequestConnecteStatesInProgress(_iOnlyInProgress: boolean): StateExportConnectedRequest | undefined {
        let memState = this.GetMemoryStatesExportConnectedDevices();
        if (memState && memState.Exists()) {
            let ReqInProgres = memState.Exports.filter(e => e.FileExporting && (!_iOnlyInProgress || (e.IsConnectedSendInProgress() && e.IsFinished == false)) && e.GetExportRequestUid());

            if (ReqInProgres?.length > 0) {
                let req: StateExportConnectedRequest = new StateExportConnectedRequest();
                for (let ndxProg = 0; ndxProg < ReqInProgres.length; ndxProg++) {
                    const element = ReqInProgres[ndxProg];
                    req.requestUids.push(element.GetExportRequestUid() ?? "");
                }
                return req;
            }
        }
        return undefined;
    }

    /**
    * 
    * pour les exports connectés recupere le statut jusque l appel pour envoi sur le compte connecté 
    * maj en mémoire
    * requête BACK
    * @param _iReqParams parametres
    * @param _iTraceChanges : true on met indicateur de changement (si modif :clignote icone)
    * @param _iUpdateProcessState : true il Maj du current statut qui indique SI des exports connectés sont toujours en cours de traitement(transfert envoi)
    * @param _iPollingCheckStates : true il lance au besoin le polling ttes les X seconde de statut en cours
    * @returns 
    */
    public getStatesSendConnected(_iReqParams: StateExportConnectedRequest, _iTraceChanges: boolean, _iUpdateProcessState: boolean, _iPollingCheckStates: boolean): Observable<ApiExportedFileConnectedDeviceModel[]> {

        return this.httpRequestService.PostRequest(this.baseUrl + environment.Precizion.get_consoles_send_status, _iReqParams, 'getStatesSendConnected').pipe(
            map(
                (response) => {

                   
                    let oStates: ApiExportedFileConnectedDeviceModel[] = [];
                  
                    if (response && response.length > 0) {
                        for (let ndxRec = 0; ndxRec < response.length; ndxRec++) {
                            const jsonRecord = response[ndxRec];
                            if (jsonRecord) {
                                oStates.push(new ApiExportedFileConnectedDeviceModel(jsonRecord, true));
                            }
                        }
                        

                        let changed = this.AddMemoryExportsConnectedStates(oStates, false);
                        let sfxTrace = Math.floor(Math.random() * 100).toString();
                       
                        if (_iTraceChanges && changed) {
                             this._includeDeviceChanges = true;
                              this.SetUpdateSatusPollingStatus(sfxTrace);
                           
                              let memoryStates = this.GetMemoryExportConnectedDevices(false);
                              if(memoryStates && memoryStates.Exports && memoryStates.Exports.findIndex(r=>r.IsFinished == null || r.IsFinished == false) == -1){
                                //provoque maj grid et stop loader
                                this.SetStopPollingStatus();
                              }
                             
                        }
                           
                    }
                    if (_iUpdateProcessState == true) {
                        this.updateStatusConnectedStateInProgress();

                    }
                    if (_iPollingCheckStates) {

                        this.startPollingCheckLastStatus();

                    }

                    return oStates;
                })
        );
    }

    /**
     * Récupération pour l'utilisateur connecté si présence
     * des derniers état d'export connectés connu (en back) des fichier exportés sur  consoles connectées
     * (conserver selon parametres d 'expiration)
     * requête BACK
     * @param _iClearMemory suppression de ceux en mémoire 
     * @param _iUpdateProcessState : true il Maj du current statut qui indique SI des exports connectés sont toujours en cours de traitement(transfert envoi)
     *  * @param _iPollingCheckStates : true il lance au besoin le polling ttes les X seconde de statut en cours
     * @returns 
     */
    public getUserLastConnectedExports(_iClearMemory: boolean, _iUpdateProcessState: boolean, _iPollingCheckStates: boolean): Observable<ApiExportedFileConnectedDeviceModel[]> {
        if (_iClearMemory) {
            this.SetMemoryExportConnectedDevices(null)
        }
        return this.httpRequestService.PostRequest(this.baseUrl + environment.Precizion.get_user_last_consoles_send_status, null, 'getUserLastConnectedExports').pipe(
            map(
                (response) => {
                    
                    let oStates: ApiExportedFileConnectedDeviceModel[] = [];

                    if (response && response.length > 0) {
                        for (let ndxRec = 0; ndxRec < response.length; ndxRec++) {
                            const jsonRecord = response[ndxRec];
                            if (jsonRecord) {
                                oStates.push(new ApiExportedFileConnectedDeviceModel(jsonRecord, true));
                            }

                        }
                        let changed = this.AddMemoryExportsConnectedStates(oStates, false);
                        if (changed) {
                            this._includeDeviceChanges = true;
                        }
                        if (_iUpdateProcessState == true) {
                            this.updateStatusConnectedStateInProgress();
                        }
                        if (_iPollingCheckStates) {
                            this.startPollingCheckLastStatus();
                        }
                    }
                    return oStates;
                })
        );
    }

    /**
   * Maj du current statut qui indique SI des exports connectés sont toujours en cours de traitement(transfert envoi)
   */
    private updateStatusConnectedStateInProgress() {

        if (this.ExistExportStateConnectedDevices()) {
            let dd: number | undefined = this.GetParamsRequestConnecteStatesInProgress(true)?.requestUids?.length;
            this._includeProcessStats = dd !== undefined && dd > 0;

        } else {
            this._includeProcessStats = null;
        }

    }

    //#region pooling status check

    /**lancement si pas déjà actif du le Polling de contrôle des  derniers statut d export connecté */
    private startPollingCheckLastStatus() {
        if (this?._poolingLaunched !== true && this._includeProcessStats == true && this._poolingStatusSeconds > 0 && !this.IsPollingLastStatusProcess() && this.IncludeConnecteStatesInProgress()) {
            let mSec = this._poolingStatusSeconds * 1000;
            this._poolingLaunched = true;
            this.SetstartPollingStatus();
            this.intervalPoolingCheckStates = window.setInterval(() => {
                this.PollingUpdateLastChangesStatus();
            }, mSec);

        }
    }

    /**
     * Contrôle la présence de statut en cours, et maj et en mémoire
     * maj _includeProcessStats
     * stopPolling
     * 
     */
    private PollingUpdateLastChangesStatus() {
        if (this._includeProcessStats == true) {

            let reqUpdateState = this.GetParamsRequestConnecteStatesInProgress(true);

            if (reqUpdateState && reqUpdateState?.requestUids?.length > 0) {

                this.getStatesSendConnected(reqUpdateState, true, true, false).subscribe(
                    (newSUpdateState: ApiExportedFileConnectedDeviceModel[]) => {
                        if (this.IsPollingLoadingExceedTime(this._poolingDurationMaxMin)) {
                            this._includeProcessStats = false;
                            this.stopPollingCheckLastStatus();
                        }
                    },
                )
            } else {
                this._includeProcessStats = false;
                this.stopPollingCheckLastStatus();
            }

        } else {
            this.stopPollingCheckLastStatus();
        }
    }

    /**Stop le Polling de contrôle des  derniers statut d export connecté 
     * sur le Polling de contrôle des  derniers statut d export connecté
    */
    private stopPollingCheckLastStatus() {

        this.SetStopPollingStatus();
        clearInterval(this.intervalPoolingCheckStates);
        this._poolingLaunched = false;
    }
    /**Changement du statut  vers "en cours de recuperation des derniers statut via polling"
     * sur le Polling de contrôle des  derniers statut d export connecté
    */
    private SetstartPollingStatus(): void {
        this._lastDatePolling = new Date();
        this._behaviorPollingProcessStatus.next('PROCESS');
    }

    /**Notif maj non final d'enregistrement maj */
    private SetUpdateSatusPollingStatus(_iSfx:string): void {
        this._subjectPollingProcessStatus.next('UPDATEDSTATUS_DATE_' + _iSfx);
    }

    /**Changement du statut  vers "fin de de recuperation des derniers statut via polling"
     * sur le Polling de contrôle des  derniers statut d export connecté
    */
    private SetStopPollingStatus(): void {
        this._lastDatePolling = null;
        this._behaviorPollingProcessStatus.next('END');
    }

    /**
     * Indique si il a un polling des derniers status en cours
     * @returns 
     */
    public IsPollingLastStatusProcess(): boolean {
        return this._behaviorPollingProcessStatus?.getValue() == 'PROCESS';
    }

    /**
     * Observable attend si il est  "en fin de recuperation des derniers statut via polling"
     * sur le Polling de contrôle des  derniers statut d export connecté
     * Ecoute à chaque Ajout via SetStopPollingStatus
     * @returns 
     */
    public onEndPollingLastStatus(): Observable<string> {
        return this._behaviorPollingProcessStatus.asObservable().pipe(
            filter(value => value == 'END')
           
        );
    }
    /**
     * Observable attend si il est  "en cours de recuperation des derniers statut via polling, ou si il l a terminé"
     * sur le Polling de contrôle des  derniers statut d export connecté
     * Ecoute à chaque Ajout via SetstartPollingStatus
     * @returns 
     */
    public onStartPollingLastStatus(): Observable<string> {
        return this._behaviorPollingProcessStatus.asObservable().pipe(
            filter(value => value == 'PROCESS')
        );
    }

    /**
     * Observable attend si il dispose d'un etat une nouvelle maj de statut d export est présent
     * Ecoute à chaque ajout via SetUpdateSatusPollingStatus
     * @returns 
     */
    public onChangeUpdateStatePollingLastStatus(): Observable<string> {
        return this._subjectPollingProcessStatus.asObservable().pipe(
            filter(value =>value.startsWith("UPDATEDSTATUS_DATE_")),
        );
    }


    /**
     * Retourne si le polling est commencé depuis _iMinutes
     * @param _iMinutes minute depassées
     * @returns 
     */
   public IsPollingLoadingExceedTime(_iMinutes: number): boolean {
        if (this._lastDatePolling != null) {
            const target = new Date(this._lastDatePolling).getTime();
            const now = Date.now();
            return now - target > _iMinutes * 60 * 1000;
        }
        return false;

    }

    //#endregion

    //#endregion

    public Downlaod(res: any): void {
        // doPostRequest existe dans module carto permet de simuler l'envoi d'un formulaire
        doPostRequest('POST', this.baseUrl + 'test.zip', { filePath: res, saveAs: true }, '_blank');
    }

    public getShapeDownload(param: PrecizionRequest) {
        return this.httpRequestService.PostRequest(this.baseUrl + environment.Precizion.get_shape_download, param, 'getShapeDownload').pipe(
            map(
                (response) => {
                    return response;
                })
        );
    }

    /**
     * Download the generated Export file
     * @param _iEFileDownloader structure precision File Downloader
     * @returns 
     */
    public downloadExportedFile(_iEFileDownloader: any): Observable<any> {

        return this.httpRequestService.GetExportedFile(this.baseUrl + environment.Precizion.file_download + '?ExportUId=' + _iEFileDownloader.Uid, _iEFileDownloader).pipe(
            map((response: any) => {
                if (response) {
                    this.downLoadBlobFile(response, _iEFileDownloader.BlobFileType, _iEFileDownloader.Name)
                    return true;
                } else {
                    return throwError(new Error("no yet available file"));
                }

            }),
            catchError(err => {
                return throwError(err);
            })
        )
    }



    /**
  * Method is use to download file.
  * @param data - Array Buffer data
  * @param type - type of the document. 'application/zip, application/octet-stream'
  *  @param _iFileName - file name to set on file
  */
    private downLoadBlobFile(data: any, _iBlobType: string, _iFileName: string) {
        let blob = new Blob([data], { type: _iBlobType, });
        let url = window.URL.createObjectURL(blob);

        if (_iFileName && _iFileName != "") {
            const anchor = document.createElement("a");
            anchor.download = _iFileName;
            anchor.href = url;
            anchor.click();
        } else {
            let pwa = window.open(url);
            if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
                alert('Veuillez désactiver votre bloqueur de popup et essayer à nouveau.');
            }
        }
    }

    /**
     * Retourne les unités de convertion pour les shape
     * @param _iBasicUnit
     * @param _iShapeConvertUnit ensemble des unités convertibles
     * @returns
     */
    public GetShapeConvertUnit(_iBasicUnit: string, _iShapeConvertUnit: any[]) {
        let oConvertUnit: ViewShapeConvertUnit;
        let preselected = null;
        let units: any[] = [];

        if (_iBasicUnit && _iShapeConvertUnit && _iShapeConvertUnit.length) {
            let upp_basic_unit = _iBasicUnit.toUpperCase();
            let _ShapeConvertUnit = _iShapeConvertUnit[0];
            if (_ShapeConvertUnit[upp_basic_unit]) {
                let currentkey = _ShapeConvertUnit[upp_basic_unit].key;
                let formatkey = currentkey + "_" + currentkey;
                Object.keys(_ShapeConvertUnit[upp_basic_unit].targets).forEach((key) => {
                    let element = _ShapeConvertUnit[upp_basic_unit].targets[key];

                    // id selectionné
                    if (element.key == formatkey) {
                        preselected = element.key;
                    }
                    units.push({ key: element.key, text: this.FormatUnitOnArea(element.translate) })
                });
            }
            oConvertUnit = new ViewShapeConvertUnit(preselected, units)
        }
        return oConvertUnit;

    }

    /**
     * Formatage d'une unité en ajoutant à l hectare (+/ha)
     * @param _iUnit l'unité
     * @returns
     */
    public FormatUnitOnArea(_iUnit: string): string {
        return HandleService.FormatUnitOnArea(_iUnit)

    }


    /**Retourne l'ensemble des unités de convertion pour les shapefiles */
    public GetDatasShapeConvertUnits(): any[] {
        let oUnitsConvert: any[] = [{
            "T": {
                key: "T",
                targets: {
                    "T_KG": { key: "T_KG", translate: "Kg" },
                    "T_T": { key: "T_T", translate: "T" },
                }
            },
            "KG": {
                key: "KG",
                targets: {
                    "KG_T": { key: "KG_T", translate: "T" },
                    "KG_KG": { key: "KG_KG", translate: "Kg" },
                }
            },
            "L": {
                key: "L",
                targets: {
                    "L_M3": { key: "L_M3", translate: "m3" },
                    "L_L": { key: "L_L", translate: "L" },
                }
            },
            "M3": {
                key: "M3",
                targets: {
                    "M3_L": { key: "M3_L", translate: "L" },
                    "M3_M3": { key: "M3_M3", translate: "m3" },
                }
            },
        }];
        return oUnitsConvert;
    }

    //#region Memory


    /**
     * Retourne le référentiel depuis la mémoire si présent sur cette clés
     * @param _iMemRefKey clés référentiel
     * @returns 
     */
    private GetMemoryReferential(_iMemRefKey: string): string | null {
        return !localStorageService.get(_iMemRefKey) || localStorageService.get(_iMemRefKey).length <= 1 ? null : localStorageService.get(_iMemRefKey);
    }
    //#endregion

}

